import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export default function DButton({
    children,
    loading = false,
    disabled = false,
    fullWidth = true,
    type = "button",
    sm = false,
    lg = false,
    xs = false,
    sx: sxProp = {},
    minWidth = 64,
    ...props
}) {
    let padding = "8px 22px";
    if (xs) padding = "0px 4px";
    if (sm) padding = "4px 12px";
    if (lg) padding = "12px 28px";

    const sx = { padding, minWidth, ...sxProp };

    return (
        <Button
            variant="contained"
            fullWidth={fullWidth}
            disabled={disabled || loading}
            type={type}
            size="large"
            sx={sx}
            {...props}
        >
            {loading ? (
                <CircularProgress size={24} color="inherit" />
            ) : (
                children
            )}
        </Button>
    );
}
